import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useProjectHistory(projectId, projectPage) {
    const url = `${API_PROJECTS}/${projectId}/history` + (projectPage ? `?limit=8&offset=${projectPage === 1 ? 0 : ((projectPage - 1) * 8)}` : "")
    const {data, mutate, error} = useSWR(url)
    return {
        projectHistory: data,
        mutateProjectHistory: mutate,
        isLoadingProjectHistory: !error && !data,
        isErrorProjectHistory: error
    }
}